export * from './delete-kunden-gruppe.component';
export * from './delete-kunden-gruppe.component.module';